import React from "react";
import { Link } from "react-router-dom";

function portfolio2() {
  function linkClick() {
    window.open("https://cssguide.netlify.app", "_blank");
  }

  return (
    <div>
      <section className="intro">
        <h1 className="section__title section__title--intro">
          CSS <strong> Guide Website </strong>
        </h1>
        <p className="section__subtitle section__subtitle--intro">
          Want to learn CSS?
        </p>
        <img
          src="/assets/images/portfolio-09.jpg"
          alt="a picture of a laptop"
          className="intro__img"
        />
      </section>

      <div className="portfolio-item-individual">
        <img
          src="/assets/images/CSSGUIDESITE2.png"
          alt="temp photo change this later"
        />
        <h3 className="portfolio-header">
          A responsive educational resource to learn CSS.
        </h3>
        <p className="portfolio-paragraph">
          A site aimed to teach CSS through node interactivity and comparison.
          Filled with dragable nodes, CSS source code, and numerous examples for
          nearly every CSS topic, this site aims to turn CSS beginners into CSS
          experts.
        </p>
        <h3 className="portfolio-btn" onClick={linkClick}>
          View the site by clicking here:
        </h3>
      </div>
    </div>
  );
}

export default portfolio2;
